import { useEffect, useState } from "react";

/**
 * A clock that re-renders the caller every `intervalMs`. Used for live
 * countdowns ("publishes in 44 min") so the banner stays truthful without a
 * page refresh. Cleans its timer up on unmount.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

/**
 * "in 44 min", "in 2 hr", "in 3 days", or "now" — a compact, human relative
 * time for a future instant `at` (ms) measured from `now` (ms). Past instants
 * read "now" because a due post is being dispatched, not overdue.
 */
export function untilLabel(at: number, now: number): string {
  const s = Math.round((at - now) / 1000);
  if (s <= 0) return "now";
  if (s < 60) return `in ${s} sec`;
  const m = Math.round(s / 60);
  if (m < 60) return `in ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `in ${h} hr`;
  const d = Math.round(h / 24);
  return `in ${d} day${d === 1 ? "" : "s"}`;
}
